/*
 * Ryan O'Dowd
 * 2024-01-22
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    smallCell: {
      display: 'flex',
      flexShrink: 1,
      justifyContent: 'flex-end',
    },
    errorTextWrapper: {
      paddingTop: 32,
    },
    errorText: {
      color: colors.primaryExtraLight,
      margin: 16,
      fontSize: 20,
      textAlign: 'center',
    },
    bold: {
      fontWeight: 'bold', // @TODO: replace with fontfamily that's bold
    },
    noVerticalPadding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    h1: {
      margin: 0,
      textAlign: 'center',
      color: colors.dialogText,
    },
    titleWrapper: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
    },
    logoLink: {
      position: 'absolute',
      top: -24, // @TODO: dynamic
      right: 0,
    },
    logo: {
      maxWidth: 200,
      maxHeight: 80,
      right: 0,
    },
    titleRow: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    goalsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
    joinCode: {
      padding: 6,
      backgroundColor: colors.accent,
      color: colors.primaryExtraDark,
      borderRadius: 6,
      fontSize: 14,
      fontWeight: '600', // @TODO: replace with fontfamily that's bold
    },
    dangerous: {
      color: colors.alert,
    },
  };
};

export default getStyles;
